import { Db } from './db';
import Code_getSourceByFileLineSql from '../../db/sql/git_blame-6.1.111.db/query-Code_getSourceByFileLine.sql';
export class Code {
    constructor(snippets, db) {
        this.snippets = snippets;
        this.db = db;
    }
    static async init(snippets) {
        return new Code(snippets, await Db.init(Code.DB_PATH));
    }
    async getSourceByFileLine($file_path, $start_line, $end_line) {
        let rows = await this.db.exec(Code_getSourceByFileLineSql, {
            $file_path, $start_line, $end_line
        });
        return rows.map(row => ({
            file_path: Db.getColumn(row, 'file_path'),
            line_no: Db.getColumn(row, 'line_no'),
            data: Db.getColumn(row, 'data'),
        }));
    }
}
Code.DB_PATH = '../db/git_blame-6.1.111.db';
